// extracted by mini-css-extract-plugin
export default {"productDetails":"ProductDetails_productDetails__po3n3","price":"ProductDetails_price__fCCbF"};